/* sb-dc-ftpreset.js - adds a 2' x 3' quick-size chip to the size panel,
   for Custom Vinyl Banners only.

   Requested 2026-09-02: the size panel offered 8x3 upward, so the smallest
   banner we actually sell had to be typed in by hand every time.

   How the chips work
   ------------------
   The size panel asks window.__dcFtChips(defaults) for its list. That hook
   lives in sb-dc-aug.js and returns either the product's own preset list or
   the panel's defaults filtered by the product's ft rule. Entries are [w, h]
   pairs in FEET - not "2x3" strings; a string gets read as w="2", h="x" and
   renders as 2' x '.

   Rather than re-upload the 328 KB augment bundle for one pair, this wraps
   that hook: same list, with [2, 3] in front, and only when the applied
   product is custom-vinyl-banners. Every other product is handed back exactly
   what the bundle returned.

   2x3 is a real orderable size - variant "2 / 3" exists on the product at
   $11.94 ($1.99/sq.ft x 6) and is in stock - so sizeguard and the cart
   variant lookup both resolve it normally.

   Load order: anywhere after sb-dc-aug.js. It polls for the hook rather than
   assuming it is there, and marks itself so a second load cannot double-wrap. */
(function () {
  var HANDLE = 'custom-vinyl-banners';
  var W = 2, H = 3;
  var tries = 0;

  function already(list) {
    for (var i = 0; i < list.length; i++) {
      var q = list[i];
      if (q && Number(q[0]) === W && Number(q[1]) === H) return true;
    }
    return false;
  }

  function appliesHere() {
    try {
      var ap = window.__dcAppliedProduct && window.__dcAppliedProduct();
      return !!(ap && ap.handle === HANDLE);
    } catch (e) { return false; }
  }

  function install() {
    if (window.__dcFtPresetWrapped) return true;
    var orig = window.__dcFtChips;
    if (typeof orig !== 'function') return false;

    window.__dcFtChips = function () {
      var out;
      try { out = orig.apply(this, arguments); } catch (e) { throw e; }
      try {
        if (Array.isArray(out) && appliesHere() && !already(out)) {
          out = [[W, H]].concat(out);
        }
      } catch (e) { /* a broken chip list must never take the panel down */ }
      return out;
    };

    window.__dcFtPresetWrapped = true;
    return true;
  }

  if (!install()) {
    var t = setInterval(function () {
      if (install() || ++tries > 100) clearInterval(t);
    }, 200);
  }

  window.__dcFtPreset = function () {
    return { wrapped: !!window.__dcFtPresetWrapped, handle: HANDLE, size: [W, H] };
  };
})();
